import ProductUpdate from './ProductUpdate'
export {ProductUpdate}
export default ProductUpdate
